module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.7-120.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.7.md
// module id = 537
// module chunks = 271